function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}

export const appVersion = assertValue(process.env.VITE_VERSION, "Missing environment variable: VITE_VERSION");

export const supabaseUrl = assertValue(
  process.env.VITE_SUPABASE_URL,
  "Missing environment variable: VITE_SUPABASE_URL"
);

export const supabaseAnonKey = assertValue(
  process.env.VITE_SUPABASE_ANON_KEY,
  "Missing environment variable: VITE_SUPABASE_ANON_KEY"
);

export const googleMapsApiKey = assertValue(
  process.env.VITE_GOOGLE_MAPS_API_KEY,
  "Missing environment variable: VITE_GOOGLE_MAPS_API_KEY"
);

export const oneSignalKey = assertValue(
  process.env.VITE_ONE_SIGNAL_KEY,
  "Missing environment variable: VITE_ONE_SIGNAL_KEY"
);

export const mobileHost = assertValue(process.env.VITE_MOBILE_HOST, "Missing environment variable: VITE_MOBILE_HOST");

export const viteMode = assertValue(process.env.VITE_MODE, "Missing environment variable: VITE_MODE");
